import { SwapOutlined } from '@ant-design/icons';
import { Card, Descriptions, Tag } from 'antd';

interface TransactionInfoCardProps {
    hasTransfer: boolean;
    lastTransferAmountDisplay: string;
    lastTransferDateDisplay: string;
}

export const TransactionInfoCard = ({
    hasTransfer,
    lastTransferAmountDisplay,
    lastTransferDateDisplay,
}: TransactionInfoCardProps) => (
    <Card
        size="small"
        title={
            <span className="inline-flex items-center gap-2 font-medium">
                <SwapOutlined className="text-violet-600" />
                Transaction Info
            </span>
        }
        className="mb-5 rounded-lg shadow-sm"
    >
        <Descriptions
            bordered
            column={1}
            size="small"
            className="[&_.ant-descriptions-item-label]:bg-slate-50 [&_.ant-descriptions-item-label]:font-semibold [&_.ant-descriptions-item-content]:bg-white [&_.ant-descriptions-item-content]:font-medium"
        >
            <Descriptions.Item label="Last Transferred Transaction Amount">
                {hasTransfer ? (
                    <Tag color="purple">{lastTransferAmountDisplay}</Tag>
                ) : (
                    <Tag color="gold">N/A</Tag>
                )}
            </Descriptions.Item>
            <Descriptions.Item label="Last Transaction Transfer Date">
                {hasTransfer ? <Tag color="purple">{lastTransferDateDisplay}</Tag> : <Tag color="gold">N/A</Tag>}
            </Descriptions.Item>
        </Descriptions>
    </Card>
);
